import { useRef, useEffect, useContext, useState } from 'react';

import { GlobalContext } from "./contexts/globalContext";

import styles from './app.module.css';

import LoginComponent from './components/LoginComponent';
import ProjectsListComponent from './components/ProjectsListComponent';
import RegisterDeviceComponent from './components/registerDevice/RegisterDeviceComponent';
import SocketManager from './utils/SocketManager';
import SocketManagerLocal from './utils/SocketManagerLocal';
import ConferenceScreenComponent from "./components/conferenceScreen/ConferenceScreenComponent"
import AlertComponent from "./components/commons/AlertComponent";
import New_KeyboardComponent from './components/keyboard/New_KeyboardComponent';
import MediasoupInitializer from './components/conferenceScreen/MediasoupInitializer';
import SettingsComponent from './components/settings/SettingsComponent';
import StationMapComponent from './components/settings/StationMapComponent';

import { ApiGetRegisterStatus } from './utils/RestServices';

import { jwtDecode } from 'jwt-decode';


function App() {


    const { socketToken, setSocketToken, keyboardRef, socketRef, roomDataForRegister, setRoomDataForRegister, setDeskData, setDeviceId, localSocketRef,
        currentUser, setInvitationData, appHeight, setAppHeight, appWidth, setAppWidth, currentConference, iamRoomAdministrator } = useContext(GlobalContext);

    const windowRef = useRef();

    const [initializeMediasoup, setInitializeMediasoup] = useState(true);
    const [openStationsMap, setOpenStationsMap] = useState(false)
    const [onlineDevices, setOnlineDevices] = useState([])
    const [deviceToStart, setDeviceToStart] = useState()
    const [desksIdsForAnim, setDesksIdsForAnim] = useState([])
    const [showRoomSettings, setShowRoomSettings] = useState(false)
    const [dontHaveDeviceIdParam, setDontHaveDeviceIdParam] = useState()

    useEffect(() => {
        document.documentElement.style.setProperty('--overflowY', "hidden");
        document.addEventListener('contextmenu', function (e) {
            e.preventDefault();
        });

        //Calculate app heigt and width
        var ratioApp = process.env.REACT_APP_WIDTH / process.env.REACT_APP_HEIGHT;
        var ratioWindow = window.innerWidth / window.innerHeight;
        var newAppWidth = process.env.REACT_APP_WIDTH;
        var newAppHeight = process.env.REACT_APP_HEIGHT;

        var ratio = 1

        if (ratioApp > ratioWindow) {
            ratio = window.innerHeight * process.env.REACT_APP_WIDTH / (window.innerWidth * process.env.REACT_APP_HEIGHT);
            newAppHeight = process.env.REACT_APP_HEIGHT * ratio;
        } else {
            ratio = window.innerWidth * process.env.REACT_APP_HEIGHT / (window.innerHeight * process.env.REACT_APP_WIDTH);
            newAppWidth = process.env.REACT_APP_WIDTH * ratio;
        }

        setAppHeight(newAppHeight);
        setAppWidth(newAppWidth);

        //End- Calculate app heigt and width

        windowRef.current.style.transformOrigin = 'top left';
        windowRef.current.style.transform = `scale(${window.innerWidth / newAppWidth}, ${window.innerHeight / newAppHeight})`;


        const urlParams = new URLSearchParams(window.location.search);

        const token = urlParams.get('token');
        const deviceIdParam = urlParams.get('deviceId')


        if (token) {
            let tokenData = getUserDataFromToken(token);
            setInvitationData(tokenData)
        }

        if (deviceIdParam) {
            getDeskData(deviceIdParam)
            setDontHaveDeviceIdParam(false)
        } else {
            setDontHaveDeviceIdParam(true)
        }

        const handler = e => { e.preventDefault(); };
        window.addEventListener('contextmenu', handler)

        return () => {
            window.removeEventListener('contextmenu', handler)
        }
    }, [])

    const handleGetMac = (mac) => {
        console.log("handleGetMac mac: ", mac)
        if (mac) {
            getDeskData(mac)
        }
    }

    const getDeskData = (deviceIdParam) => {
        setDeviceId(deviceIdParam);

        var body = JSON.stringify({
            deviceId: deviceIdParam
        });

        ApiGetRegisterStatus(body, data => {
            if (data.registered) {
                setDeskData(data.response);
                setSocketToken(data.response.token);
            } else {
                setRoomDataForRegister(data.response)
            }
        });
    }

    const getUserDataFromToken = (token) => {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        if (!showRoomSettings) setOpenStationsMap(false)
    }, [showRoomSettings])

    const onDeskClicked = (deviceId, isOnline, currentDevice = false) => {
        if (isOnline) {
            if (currentDevice && currentConference) {
                socketRef.current.emit("STOP_CONFERENCE", currentConference._id)

                setTimeout(() => {
                    if (currentConference.type === "Presentation") {
                        socketRef.current.emit("PRESENTATION_EXIT", currentConference);
                    } else if (currentConference.type === "Meeting") {
                        socketRef.current.emit("MEETING_EXIT", currentConference);
                    }
                }, 300)

            }

            setTimeout(() => {
                socketRef.current.emit("SHUTDOWN", deviceId)
            }, 600)

        } else {
            setDeviceToStart(deviceId);
            if (localSocketRef.current?.connected) {
                localSocketRef.current.emit("systemInfo:wakeOnLan", deviceId);
            }
        }
    }

    return (
        <div ref={windowRef} className={styles.app_body} style={{ height: `${appHeight}px`, width: `${appWidth}px` }}>
            {socketToken &&
                <SocketManager />}

            {dontHaveDeviceIdParam && <SocketManagerLocal onGetMac={handleGetMac} />}

            {!currentUser && !roomDataForRegister && !currentConference && <LoginComponent />}
            {currentUser && <ProjectsListComponent />}
            {roomDataForRegister && <RegisterDeviceComponent />}

            {currentConference && <ConferenceScreenComponent />}

            <AlertComponent />
            <New_KeyboardComponent ref={keyboardRef} width="2140px" height="610px" s="1" position="absolute" />

            {initializeMediasoup && <MediasoupInitializer setInitializeMediasoup={setInitializeMediasoup}></MediasoupInitializer>}

            {!currentUser && !roomDataForRegister && !currentConference && iamRoomAdministrator && <StationMapComponent openStationsMap={openStationsMap} setOpenStationsMap={setOpenStationsMap} onlineDevices={onlineDevices}
                deviceToStart={deviceToStart} desksIdsForAnim={desksIdsForAnim} setDesksIdsForAnim={setDesksIdsForAnim} onDeskClicked={onDeskClicked} />}

            {!currentUser && !roomDataForRegister && !currentConference && iamRoomAdministrator &&
                <SettingsComponent showRoomSettings={showRoomSettings} openStationsMap={openStationsMap} setOpenStationsMap={setOpenStationsMap} onlineDevices={onlineDevices} onDeskClicked={onDeskClicked}
                    setOnlineDevices={setOnlineDevices} deviceToStart={deviceToStart} setDeviceToStart={setDeviceToStart} desksIdsForAnim={desksIdsForAnim} setDesksIdsForAnim={setDesksIdsForAnim} />
            }

            {!currentUser && !roomDataForRegister && !currentConference && iamRoomAdministrator &&
                <div
                    style={{
                        zIndex: 999, left: "15px", width: "100px", bottom: "-25px", position: "absolute", color: `${showRoomSettings ? "white" : "#726FA8"}`, cursor: "pointer", display: "flex",
                        flexDirection: "column", alignItems: "center", marginBottom: "40px"
                    }}
                    onClick={() => setShowRoomSettings(!showRoomSettings)}
                >
                    <i className="fa-thin fa-cog" style={{ fontSize: "50px" }}></i>
                    <div style={{ font: "normal normal 600 18px/22px Bio Sans", margin: "10px", marginTop: "20px" }}>SETTINGS</div>
                </div>
            }
        </div>
    );
}

export default App;
